import { render } from "./PdfExtractionPreviewModal.vue?vue&type=template&id=6772618e&scoped=true"
import script from "./PdfExtractionPreviewModal.vue?vue&type=script&lang=js"
export * from "./PdfExtractionPreviewModal.vue?vue&type=script&lang=js"

import "./PdfExtractionPreviewModal.vue?vue&type=style&index=0&id=6772618e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6772618e"]])

export default __exports__